<template lang="pug">
  dl
    dt {{ title }}
    dd
      table(v-if="loginHistory")
        tr(v-for="event in formattedLoginHistory")
          td {{ event.date | shortDate }}
          td {{ event.type }}
              td {{ event.desc }}
</template>

<script>
import _ from 'lodash';

export default {
  name: 'Interactions',
  props: {
    loginHistory: {
      type: null
    },
    patientAge: {
      type: null
    },
    patientGender: {
      type: String
    },
    showRecentOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    eventTypeToString(eventType) {
      if (eventType === 'LOGIN' || eventType === 'TOKEN_VERIFIED') {
        return 'Login';
      }
      if (eventType === 'LOGIN_ATTEMPT') {
        return 'Login Fail';
      }
      if (eventType === 'REGISTER') {
        return 'Register';
      }
    },
    eventSubTypeToString(eventSubType) {
      if (!eventSubType) {
        return 'Web';
      }
      if (eventSubType === 'WEB' || eventSubType === 'SSO_WEB') {
        return 'Web';
      }
      if (eventSubType === 'MOBILE' || eventSubType === 'SSO_MOBILE' || eventSubType === 'MOBILE_REAUTH') {
        return 'Mobile';
      }
    }
  },
  computed: {
    title() {
      return this.showRecentOnly ? 'Recent Interactions' : 'Interaction History';
    },
    formattedLoginHistory() {
      if (_.isArray(this.loginHistory) && !_.isEmpty(this.loginHistory)) {
        const interactions = this.showRecentOnly ? _.take(this.loginHistory, 3) : this.loginHistory;
        return interactions
          .filter(interaction => {
            return interaction.eventType === 'LOGIN' ||
              interaction.eventType === 'TOKEN_VERIFIED' ||
              interaction.eventType === 'LOGIN_ATTEMPT' ||
              interaction.eventType === 'REGISTER';
          })
          .map(interaction => {
            return {
              date: interaction.createdOn,
              type: this.eventTypeToString(interaction.eventType),
              desc: this.eventSubTypeToString(interaction.eventSubType)
            };
          });
      }
      return [];
    }
  }
};
</script>
